import React from "react";
import { string } from "prop-types";
import { floorPlanShape } from "../../common/floorPlan.js";
import { NavLink, Route, Switch, useLocation } from "react-router-dom";
import { ListIcon, MapPinIcon } from "../../common/icons.jsx";

import useHashSlash from "../../common/routing/useHashSlash.js";
import useDefaultPathname from "../../common/routing/useDefaultPathname.js";

import DetailPage from "../DetailPage/DetailPage.jsx";
import FloorPlanUnitList from "./FloorPlanUnitList.jsx";
import MapViewSimple from "../MapView/MapViewSimple.jsx";

const propTypes = {
  floorPlan: floorPlanShape.isRequired,
  listingUrl: string.isRequired,
};

const FloorPlanDetailPage = props => {
  const { listingUrl } = props;

  const {
    area,
    bathrooms,
    bedrooms,
    attributes,
    floorPlan,
    image,
    startingAt,
    units,
    sightmapEmbed,
  } = props.floorPlan;

  const views = [
    {
      id: "unit",
      label: "Homes View",
      icon: ListIcon,
      render: routeProps => <FloorPlanUnitList units={units} />,
    },
  ];

  //if sightmap embed exists show map tab
  if (sightmapEmbed) {
    views.push({
      id: "map",
      label: "Map View",
      icon: MapPinIcon,
      render: routeProps => <MapViewSimple floorPlan={floorPlan} />,
    });
  }

  const location = useLocation();

  useHashSlash();

  // NOTE: this is removed due to issue where path name is injected into URL after UTM parameters (see LMCS-93)
  // if there is no view selected, select the first one
  useDefaultPathname(`/${views[0].id}`);

  return (
    <DetailPage
      listingUrl={listingUrl}
      actionBarRight={
        <div className="action-bar__toggles">
          {views.map(view => (
            <div key={view.id} className="action-bar__button">
              <NavLink
                aria-label={view.label}
                to={{ ...location, pathname: `/${view.id}` }}
                className="toggle-button"
                activeClassName="toggle-button--selected"
              >
                <view.icon className="toggle-button__icon" />
                {view.label}
              </NavLink>
            </div>
          ))}
        </div>
      }
    >
      <div className="floor-plan-detail">
        <div className="floor-plan-detail__overview">
          <div className="floor-plan-detail__info">
            <h1 className="floor-plan-detail__title coh-style-color-1 coh-style-heading-3-alt-size">
              {floorPlan}
            </h1>
            <ul className="floor-plan-detail__stats coh-style-heading-4-size">
              <li>{area} Sq. Ft.</li>
              <li>{bedrooms}</li>
              <li>{bathrooms}</li>
              <li>Starting at {startingAt}</li>
              {(attributes && <li>Features: {attributes.join(", ")}</li>)}
            </ul>
          </div>
          <div className="floor-plan-detail__image">
            <img src={image} alt={`Floorplan ${floorPlan}`} />
          </div>
        </div>
      </div>
      <Switch>
        {views.map(view => {
          const { id, render } = view;
          return <Route key={id} path={`/${id}`} render={render} />;
        })}
      </Switch>
    </DetailPage>
  );
};

FloorPlanDetailPage.propTypes = propTypes;
export default FloorPlanDetailPage;
